import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../common/Button/Button';
import Gallery from '../Gallery/Gallery';
import styles from './Hero.module.css';

const stats = [
  { num: '200+', label: 'Học viên' },
  { num: '5+', label: 'Năm kinh nghiệm' },
  { num: '900+', label: 'Điểm TOEIC cao nhất' },
];

/**
 * Full-width hero section for the Home page.
 */
function Hero() {
  const navigate = useNavigate();

  return (
    <section className={styles.hero} aria-label="Hero">
      <h1 className={styles.heading}>
        Thành thạo ngôn ngữ —<br />
        <em>mở khoá phiên bản tốt hơn của chính bạn</em>
      </h1>

      <p className={styles.sub} style={{ fontSize: '1.1rem', fontStyle: 'italic', marginBottom: '20px' }}>
        More than a language class
      </p>

      <p className={styles.sub}>
        Tại Annie's Class, bên cạnh việc hệ thống hóa kiến thức sát với các kỳ thi, Annie còn chú trọng
        vào phản xạ và tương tác thực tế trong suốt quá trình học. Bạn sẽ dần quen với việc nghe, hiểu
        và diễn đạt suy nghĩ của mình qua mỗi ngôn ngữ một cách tự nhiên nhất.
        <br /><br />
        Vì Annie tin rằng, giá trị thật sự của ngoại ngữ không chỉ nằm trên những trang sách hay tấm bằng
        chứng chỉ, mà còn là cánh cửa kết nối, đưa bạn chạm đến những phiên bản tốt đẹp hơn của chính mình.
      </p>

      <div className={styles.location}>
        📍 Online qua Zoom &amp; Offline tại Safira Khang Điền, Quận 9
      </div>

      <div className={styles.btns}>
        <Button variant="primary" onClick={() => navigate('/toeic')}>
          Khám phá TOEIC
        </Button>
        <Button variant="outline" onClick={() => navigate('/jlpt')}>
          Khám phá JLPT 日本語
        </Button>
      </div>

      <Gallery />

    </section>
  );
}

export default Hero;
